<youtube-player
  [videoId]="videoId"
  loadApi="true"
  [width]="width"
  [height]="height"
></youtube-player>
